import { SET_COURSE_LICENSE_STATUS } from '../types';
export const setLicenseAgreed = _ref => {
  let {
    courseId,
    status
  } = _ref;
  return {
    courseId,
    status,
    type: SET_COURSE_LICENSE_STATUS
  };
};